import { Empty } from 'antd';
import { SetStateAction, useState } from 'react';
import { TVSSearchParams } from 'shared/types/types';
import { TScheduleData } from 'shared/types/vacation-schedule.types';
import { useAppSelector } from 'app/store';
import { getAllAvailableOrganizations } from 'entities/organizations/model/organizations';
import Card from '../card';
import ModalAddSchedule from '../modalAddSchedule/index.';
import ModalReason from '../modalReason';
import NotFoundResults from '../notFoundResults';

type TCards = {
  employees: TScheduleData[];
  oldYearStatus: boolean;
  currentSearchValue: string | undefined;
  currentPage: number;
  currentSize: number;
  currentYear: number;
  setCurrentSearchValue: React.Dispatch<SetStateAction<string | undefined>>;
  isUploadTo1S: boolean;
  calendarTotalDays: number | null;
  firstRange: string | null;
  employeesTriger: (obj: TVSSearchParams) => void;
  filterState: { divisionId: string; filterEmployees: string; filterRequestStatuses: boolean; active: boolean };
};

const Cards = ({
  employees,
  oldYearStatus,
  currentSearchValue,
  currentYear,
  currentSize,
  currentPage,
  isUploadTo1S,
  setCurrentSearchValue,
  calendarTotalDays,
  firstRange,
  employeesTriger,
  filterState,
}: TCards) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isModalAddOpen, setIsModalAddOpen] = useState(false);
  const [requestId, setRequestId] = useState<number | string>();
  const [employeeId, setEmployeeId] = useState<number | string>();
  const [fio, setFio] = useState<string>('');
  const allAvailableOrganizations = useAppSelector(getAllAvailableOrganizations);

  const showModal = (requestId: string | number, employeeId: string | number): void => {
    setRequestId(requestId);
    setEmployeeId(employeeId);
    setIsModalOpen(true);
  };

  const showModalAdd = (employeeId: string | number, name: string): void => {
    setFio(name);
    setEmployeeId(employeeId);
    setIsModalAddOpen(true);
  };

  return (
    <>
      {employees && employees?.length > 0 ? (
        employees?.map(el => {
          return (
            <Card
              employeer={el}
              showModal={showModal}
              showModalAdd={showModalAdd}
              key={el?.id}
              oldYearStatus={oldYearStatus}
              isUploadTo1S={isUploadTo1S}
            />
          );
        })
      ) : currentSearchValue ? (
        <NotFoundResults
          filterState={filterState}
          currentYear={currentYear}
          currentPage={currentPage}
          currentSize={currentSize}
          setCurrentSearchValue={setCurrentSearchValue}
          employeesTriger={employeesTriger}
        />
      ) : (
        <Empty description={`Нет данных за ${currentYear} год`} />
      )}

      <ModalReason
        isModalOpen={isModalOpen}
        setIsModalOpen={setIsModalOpen}
        requestId={requestId}
        employeeId={employeeId}
      />

      <ModalAddSchedule
        isModalAddOpen={isModalAddOpen}
        setIsModalAddOpen={setIsModalAddOpen}
        employeeId={{ employeeId: Number(employeeId), allAvailableOrganizations }}
        fio={fio}
        calendarTotalDays={calendarTotalDays}
        firstRange={firstRange}
      />
    </>
  );
};

export default Cards;
